import Axios from 'axios'
import checkAuth from '~/middleware/CheckAuth'
import Models from './models'
import Services from './services'

export let api

export const install = ctx => {
  const models = Models({})
  const services = Services({ ...ctx, models })
  api = {
    models,
    services,
  }
  return api
}

export default async (ctx, inject) => {
  const syncState = () => {
    ctx.store.dispatch('coaching/serverSync')
    ctx.store.dispatch('research/serverSync')
  }
  const axiosConfig = {
    axios: Axios,
    apis: {
      main: { baseURL: ctx.env.mainApiUrl },
    },
    async refreshHandler() {
      if (!navigator.onLine) return
      const response = await this.main.post(
        '/v2/auth/app/refresh',
        {},
        { ignoreExpiredToken: true }
      )
      const newToken = response.data.session
      ctx.store.dispatch('auth/authenticate', newToken)
      return newToken
    },
    onFailRefresh(e) {
      if (e?.response?.status?.toString().startsWith('5')) return
      console.log(e)
      ctx.store.dispatch('auth/logout', {
        forced: true,
        silent: true,
        reason: `Failed refresh token (${e.message})`,
      })
    },
    responseInterceptors: [
      {
        format: res => res,
        error(e) {
          console.log({ e })
          ctx.$telemetry.pushEvent({
            category: 'axios',
            name: 'response',
            error: {
              message: e.message,
              name: e.name,
              code: e.code,
            },
            request: !e.config
              ? null
              : {
                  baseURL: e.config.baseURL ?? ctx.env.mainApiUrl ?? null,
                  url: e.config.url ?? null,
                  data: e.config.data ?? null,
                  headers: e.config.headers ?? null,
                  params: e.config.params ?? null,
                  method: e.config.method ?? null,
                },
            response: !e.response
              ? null
              : {
                  status: e.response.status ?? null,
                  statusText: e.response.statusText ?? null,
                  data: e.response.data ?? null,
                  headers: e.response.headers ?? null,
                },
          })
          if (['401', '403'].includes(e?.response?.status?.toString()))
            ctx.store.dispatch('auth/logout', {
              forced: true,
              silent: true,
              reason: `Request failed: ${e.config?.url} (${e.message})`,
            })
          return Promise.reject(e)
        },
      },
    ],
  }
  const $api = install({ ...ctx, axiosConfig })
  $api.services.server.axios
  const $axios = function $axios(payload) {
    return $api.services.server.main.request(payload)
  }
  const methods = [
    'request',
    'get',
    'post',
    'patch',
    'options',
    'delete',
    'head',
    'put',
  ]
  methods.forEach(
    method =>
      ($axios[method] = $api.services.server.main[method].bind(
        $api.services.server.main
      ))
  )
  $axios.$setToken = $api.services.server.$setToken.bind($api.services.server)
  ctx.$api = $api
  inject('api', $api)
  ctx.$axios = $axios
  ctx.app.$axios = $axios
  inject('axios', $axios)
  await checkAuth(ctx)
  setInterval(syncState, 15 * 1000)
  window.addEventListener('online', syncState)
  syncState()
}
